<template>
  <div>
    <hr class="separate-line" :style="styleSeparateLine" />
  </div>
</template>

<script>
/**
 * Linha padrao para separação de blocos de elementos
 * Ref: https://www.figma.com/file/9AFe6i7bVhMup1bYeppCU7/Tarifas?node-id=22%3A98
 */
export default {
  name: 'SeparateLine',
  props: {
    /** Espaçamento para cima da linha. Padrão 40px */
    top: {
      type: Number,
      default: 40
    },
    /** Espaçamento para direita da linha. Padrão 40px */
    right: {
      type: Number,
      default: 40
    },
    /** Espaçamento para baixo da linha. Padrão 45px */
    bottom: {
      type: Number,
      default: 45
    },
    /** Espaçamento para esquerda da linha. Padrão 40px */
    left: {
      type: Number,
      default: 40
    }
  },
  data() {
    return {
      styleSeparateLine: {
        marginTop: `${this.top}px`,
        marginRight: `${this.right}px`,
        marginBottom: `${this.bottom}px`,
        marginLeft: `${this.left}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.separate-line {
  border-color: $gray-border;
}
</style>
